const Accountprice = (amount) => {
   return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0, 
        maximumFractionDigits: 0, 
      }).format(amount)  
}

export default Accountprice